import './Skeleton.css';const skeleton = "_skeleton_1yep9_1";
const skeleton__title = "_skeleton__title_1yep9_6";
const skeleton__back = "_skeleton__back_1yep9_28";
const skeleton__button = "_skeleton__button_1yep9_28";
const styles = {
  skeleton,
  skeleton__title,
  skeleton__back,
  skeleton__button
};
export {
  styles as default,
  skeleton,
  skeleton__back,
  skeleton__button,
  skeleton__title
};
